import React, { useContext } from "react"
import { FooterContext } from "./Footer"

const useColor = () => {
  const context = useContext(FooterContext)

  return context.secondary ? "#fff" : "#000"
}

export const FacebookIcon = () => {
  const color = useColor()

  return (
    <svg
      width="42px"
      height="43px"
      viewBox="0 0 42 43"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>95342E59-F4B4-4DA9-A847-805F0952AC57@1.5x</title>
      <desc>Created with sketchtool.</desc>
      <g
        id="WEBSITE"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Responsive/CONDUCTOR"
          transform="translate(-189.000000, -2812.000000)"
        >
          <g
            id="MENU-INFERIOR-RESPONSIVE"
            transform="translate(0.000000, 2366.000000)"
          >
            <g id="Facebook" transform="translate(190.000000, 447.000000)">
              <g id="Group-4">
                <path
                  d="M20.0005255,41 L20.0005255,41 C8.95404745,41 0,31.8221014 0,20.5005386 C0,9.17789864 8.95404745,0 20.0005255,0 C31.0459525,0 40,9.17789864 40,20.5005386 C40,31.8221014 31.0459525,41 20.0005255,41 Z"
                  id="Stroke-5"
                  stroke={color || "#1C1C1B"}
                  strokeWidth="1.5"
                ></path>
                <path
                  d="M16.3069431,31.628572 L21.2931538,31.628572 L21.2931538,19.2237817 L24.771555,19.2237817 L25.1428571,15.0706738 L21.2931538,15.0706738 L21.2931538,12.7054125 C21.2931538,11.7259462 21.4901053,11.3388646 22.4436522,11.3388646 L25.1428571,11.3388646 L25.1428571,7.02857155 L21.6902856,7.02857155 C17.9804932,7.02857155 16.3069431,8.65281743 16.3069431,11.7590941 L16.3069431,15.0706738 L13.7142857,15.0706738 L13.7142857,19.2761767 L16.3069431,19.2761767 L16.3069431,31.628572 Z"
                  id="Fill-7"
                  fill={color || "#1C1C1B"}
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export const TwitterIcon = () => {
  const color = useColor()
  return (
    <svg
      width="42px"
      height="43px"
      viewBox="0 0 42 43"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>753F9924-1662-4C1F-9497-84926FEFA720@1.5x</title>
      <desc>Created with sketchtool.</desc>
      <g
        id="WEBSITE"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Responsive/Alianzas"
          transform="translate(-135.000000, -1090.000000)"
        >
          <g
            id="MENU-INFERIOR-RESPONSIVE"
            transform="translate(0.000000, 644.000000)"
          >
            <g id="Twitter" transform="translate(136.000000, 447.000000)">
              <g id="Group-2">
                <path
                  d="M20,41 L20,41 C8.95428271,41 0,31.8221014 0,20.5005386 C0,9.17789864 8.95428271,0 20,0 C31.0467683,0 40,9.17789864 40,20.5005386 C40,31.8221014 31.0467683,41 20,41 Z"
                  id="Stroke-1"
                  stroke={color || "#1C1C1B"}
                  strokeWidth="1.5"
                ></path>
                <path
                  d="M8,26.1205618 C9.97237114,27.3797001 12.3130895,28.1142862 14.8294154,28.1142862 C23.1011673,28.1142862 27.7729671,21.157574 27.4913528,14.9183894 C28.3618944,14.293618 29.117863,13.5131869 29.7142857,12.6218748 C28.9154861,12.9747746 28.0556522,13.2135951 27.1561996,13.3202114 C28.0749262,12.7722037 28.781639,11.903281 29.1146506,10.8669708 C28.253746,11.3744643 27.2996837,11.7444228 26.2856579,11.9437952 C25.4729382,11.0812695 24.3154283,10.5428573 23.0337083,10.5428573 C20.1576015,10.5428573 18.0449585,13.2146613 18.6938494,15.989883 C14.9911027,15.8043707 11.7091713,14.0388051 9.51193705,11.3542072 C8.34479018,13.3489978 8.90694807,15.956832 10.8910978,17.2778077 C10.1608279,17.2543521 9.4723183,17.0539135 8.87161244,16.7223368 C8.82556903,18.7768325 10.3032412,20.699124 12.4458659,21.1277215 C11.8183906,21.2983075 11.1320226,21.3366894 10.433876,21.203419 C11.000317,22.9668523 12.6461012,24.2483799 14.595986,24.2835633 C12.7231971,25.7463387 10.3642755,26.3988303 8,26.1205618"
                  id="Fill-3"
                  fill={color || "#1C1C1B"}
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export const InstagramIcon = () => {
  const color = useColor()

  return (
    <svg
      width="42px"
      height="43px"
      viewBox="0 0 42 43"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>50DC9984-5C32-41E4-938D-C92B93D35A4B@1.5x</title>
      <desc>Created with sketchtool.</desc>
      <g
        id="WEBSITE"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Responsive/Error-404"
          transform="translate(-243.000000, -1073.000000)"
        >
          <g
            id="MENU-INFERIOR-RESPONSIVE"
            transform="translate(0.000000, 627.000000)"
          >
            <g id="Instagram" transform="translate(244.000000, 447.000000)">
              <g id="Group-8">
                <path
                  d="M20,41 L20,41 C8.95428271,41 0,31.8221014 0,20.5005386 C0,9.17789864 8.95428271,0 20,0 C31.0467683,0 40,9.17789864 40,20.5005386 C40,31.8221014 31.0467683,41 20,41 Z"
                  id="Stroke-9"
                  stroke={color || "#1C1C1B"}
                  strokeWidth="1.5"
                ></path>
                <path
                  d="M20,9.11111111 C17.0513519,9.11111111 16.6819906,9.12390931 15.5239647,9.17830168 C14.3680197,9.23269404 13.5793552,9.42040102 12.8884934,9.69556239 C12.1747416,9.97925589 11.5691971,10.3600024 10.9657335,10.9785823 C10.3612294,11.5982286 9.99082757,12.2189414 9.71302622,12.9505721 C9.44458895,13.6587393 9.26146896,14.4671591 9.20944623,15.6509929 C9.15638305,16.8390928 9.14285714,17.2177063 9.14285714,20.2402153 C9.14285714,23.2627242 9.15638305,23.6413378 9.20944623,24.8283711 C9.26146896,26.0132714 9.44458895,26.8216912 9.71302622,27.5298585 C9.99082757,28.2614891 10.3612294,28.882202 10.9657335,29.5007818 C11.5691971,30.1193616 12.1747416,30.5001081 12.8884934,30.7838016 C13.5793552,31.058963 14.3680197,31.2477365 15.5239647,31.3021289 C16.6819906,31.3554547 17.0513519,31.3682529 20,31.3682529 C22.9486481,31.3682529 23.3180094,31.3554547 24.4760353,31.3021289 C25.6319803,31.2477365 26.4206448,31.058963 27.1115066,30.7838016 C27.8252584,30.5001081 28.4318434,30.1193616 29.035307,29.5007818 C29.6387706,28.882202 30.0091724,28.2614891 30.2869738,27.5298585 C30.555411,26.8216912 30.738531,26.0132714 30.7915942,24.8283711 C30.8446574,23.6413378 30.8571429,23.2627242 30.8571429,20.2402153 C30.8571429,17.2177063 30.8446574,16.8390928 30.7915942,15.6509929 C30.738531,14.4671591 30.555411,13.6587393 30.2869738,12.9505721 C30.0091724,12.2189414 29.6387706,11.5982286 29.035307,10.9785823 C28.4318434,10.3600024 27.8252584,9.97925589 27.1115066,9.69556239 C26.4206448,9.42040102 25.6319803,9.23269404 24.4760353,9.17830168 C23.3180094,9.12390931 22.9486481,9.11111111 20,9.11111111 M20.0000001,11.1161631 C22.8987064,11.1161631 23.2420564,11.1278948 24.3875968,11.1812206 C25.4446986,11.2302804 26.02007,11.4126548 26.4029573,11.5641002 C26.9096586,11.7667384 27.2717368,12.0077712 27.6515027,12.3970499 C28.0312686,12.7863286 28.2664113,13.15641 28.4640977,13.6768702 C28.6118422,14.068282 28.7887195,14.6580658 28.8376209,15.7427135 C28.8896436,16.9158821 28.9010886,17.2678327 28.9010886,20.2402154 C28.9010886,23.2115316 28.8896436,23.5634822 28.8376209,24.7366508 C28.7887195,25.8212985 28.6118422,26.4110823 28.4640977,26.8024941 C28.2664113,27.3229543 28.0312686,27.6930357 27.6515027,28.0833809 C27.2717368,28.471593 26.9096586,28.7126259 26.4029573,28.9152641 C26.02007,29.067776 25.4446986,29.2490839 24.3875968,29.2981437 C23.2420564,29.352536 22.8987064,29.3632012 20.0000001,29.3632012 C17.1012937,29.3632012 16.7579438,29.352536 15.6134438,29.2981437 C14.5553015,29.2490839 13.9799302,29.067776 13.5980833,28.9152641 C13.0903415,28.7126259 12.7293038,28.471593 12.3484975,28.0833809 C11.9687315,27.6930357 11.7346293,27.3229543 11.5369429,26.8024941 C11.3881579,26.4110823 11.2112807,25.8212985 11.1634197,24.7366508 C11.1103566,23.5634822 11.099952,23.2115316 11.099952,20.2402154 C11.099952,17.2678327 11.1103566,16.9158821 11.1634197,15.7427135 C11.2112807,14.6580658 11.3881579,14.068282 11.5369429,13.6768702 C11.7346293,13.15641 11.9687315,12.7863286 12.3484975,12.3970499 C12.7293038,12.0077712 13.0903415,11.7667384 13.5980833,11.5641002 C13.9799302,11.4126548 14.5553015,11.2302804 15.6134438,11.1812206 C16.7579438,11.1278948 17.1012937,11.1161631 20.0000001,11.1161631"
                  id="Fill-11"
                  fill={color || "#1C1C1B"}
                ></path>
                <path
                  d="M19.4285714,24.4647032 C17.3798325,24.4647032 15.7192982,22.7626556 15.7192982,20.6626983 C15.7192982,18.5627411 17.3798325,16.8606934 19.4285714,16.8606934 C21.4773103,16.8606934 23.1389111,18.5627411 23.1389111,20.6626983 C23.1389111,22.7626556 21.4773103,24.4647032 19.4285714,24.4647032 M19.4285714,14.8055556 C16.2728097,14.8055556 13.7142857,17.4280426 13.7142857,20.6626983 C13.7142857,23.8973541 16.2728097,26.5198411 19.4285714,26.5198411 C22.5843332,26.5198411 25.1428571,23.8973541 25.1428571,20.6626983 C25.1428571,17.4280426 22.5843332,14.8055556 19.4285714,14.8055556"
                  id="Fill-13"
                  fill={color || "#1C1C1B"}
                ></path>
                <path
                  d="M27.4285714,14.9682538 C27.4285714,15.6147851 26.9166809,16.1396824 26.2861705,16.1396824 C25.6547476,16.1396824 25.1428571,15.6147851 25.1428571,14.9682538 C25.1428571,14.3217225 25.6547476,13.7968251 26.2861705,13.7968251 C26.9166809,13.7968251 27.4285714,14.3217225 27.4285714,14.9682538"
                  id="Fill-15"
                  fill={color || "#1C1C1B"}
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export const WhatsappIcon = () => {
  const color = useColor()
  return (
    <svg
      width="42px"
      height="43px"
      viewBox="0 0 42 43"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>0B21866B-551E-43BB-90E5-078A2F0624E4@1.5x</title>
      <desc>Created with sketchtool.</desc>
      <g
        id="WEBSITE"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Responsive/Contacto"
          transform="translate(-297.000000, -1075.000000)"
        >
          <g
            id="MENU-INFERIOR-RESPONSIVE"
            transform="translate(0.000000, 629.000000)"
          >
            <g id="Whatsapp" transform="translate(298.000000, 447.000000)">
              <g id="Group-9">
                <path
                  d="M20.0005255,41 L20.0005255,41 C8.95404745,41 0,31.8221014 0,20.5005386 C0,9.17789864 8.95404745,0 20.0005255,0 C31.0459525,0 40,9.17789864 40,20.5005386 C40,31.8221014 31.0459525,41 20.0005255,41 Z"
                  id="Stroke-17"
                  stroke={color || "#1C1C1B"}
                  strokeWidth="1.5"
                ></path>
                <path
                  d="M20.1976295,28.155856 C18.3752771,28.155856 16.6839843,27.6037177 15.2672925,26.6465358 L11.8222976,27.7721306 L12.9404647,24.3868192 C11.8680644,22.8828285 11.2346097,21.0366826 11.2346097,19.0423761 C11.2346097,18.7449888 11.2481318,18.4497334 11.2793364,18.1576757 C11.718282,13.5444428 15.551255,9.92889612 20.1976295,9.92889612 C24.9032929,9.92889612 28.7716311,13.6361105 29.1304848,18.3314181 C29.1502477,18.5669829 29.1606493,18.8025477 29.1606493,19.0423761 C29.1606493,24.0702457 25.1383681,28.155856 20.1976295,28.155856 M30.8519421,18.7663063 C30.7073605,12.9049001 25.9964963,8.19999978 20.1976295,8.19999978 C14.467413,8.19999978 9.79711494,12.7983097 9.54747762,18.5669823 C9.54227685,18.7247361 9.53707607,18.8835558 9.53707607,19.0423755 C9.53707607,21.0931748 10.0956396,23.0054066 11.0650645,24.6426352 L9.14285714,30.4571416 L15.0467796,28.5342507 C16.574768,29.3933694 18.3305505,29.8847511 20.1976295,29.8847511 C26.0869898,29.8847511 30.8571429,25.0306242 30.8571429,19.0423755 C30.8571429,18.9496418 30.8571429,18.8579741 30.8519421,18.7663063"
                  id="Fill-19"
                  fill={color || "#1C1C1B"}
                ></path>
                <path
                  d="M25.7086646,21.8754234 C25.4233044,21.7513779 24.0446228,21.1519902 23.7861201,21.0706164 C23.5287363,20.9852731 23.3407343,20.9465709 23.1527323,21.1946619 C22.9647303,21.4417604 22.4219863,21.9994688 22.2608417,22.1612241 C22.0952209,22.3279412 21.9340763,22.3467961 21.6487161,22.223743 C21.3700702,22.0996975 20.4636319,21.841683 19.3893346,20.9942044 C18.5556351,20.3422214 17.9882718,19.533445 17.8260082,19.2853541 C17.6659827,19.0382556 17.8092223,18.9042865 17.9491048,18.780241 C18.0789157,18.6671115 18.2288697,18.4904708 18.3732284,18.3475704 C18.4112764,18.3039064 18.4437291,18.2661966 18.4761819,18.2284868 C18.5410873,18.1381817 18.5892069,18.051846 18.6529933,17.9327624 C18.7492324,17.7660453 18.7011129,17.6231449 18.6317312,17.5000918 C18.5612304,17.3760464 17.9972243,16.1574238 17.7611027,15.6622343 C17.5305764,15.1670448 17.2944548,15.2523881 17.127715,15.2523881 C16.9665704,15.2523881 16.7796874,15.2285713 16.5916854,15.2285713 C16.4036833,15.2285713 16.097061,15.2900979 15.8396773,15.5381888 C15.5811745,15.7852874 14.8571429,16.3856674 14.8571429,17.60429 C14.8571429,17.8900908 14.915334,18.1758915 15.0026206,18.4468068 C15.2868618,19.3181021 15.8978684,20.0375658 16.0064172,20.1616113 C16.1451806,20.3233665 17.9491048,22.9045045 20.8060641,23.8998453 C23.6686188,24.8852624 23.6686188,24.5557977 24.1833862,24.513126 C24.6992728,24.4754162 25.8485471,23.9187002 26.0790733,23.3371751 C26.3151949,22.7616041 26.3151949,22.2664146 26.2446942,22.1612241 C26.1753125,22.0609954 25.9873105,21.9994688 25.7086646,21.8754234"
                  id="Fill-21"
                  fill={color || "#1C1C1B"}
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}
export const EmailIcon = () => {
  const color = useColor()

  return (
    <svg
      width="42px"
      height="43px"
      viewBox="0 0 40 40"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <polygon
          id="path-1"
          points="0.0647 0.4395 39.6247 0.4395 39.6247 40 0.0647 40"
        ></polygon>
      </defs>
      <g
        id="STYLE-GUIDE"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="MENU-ORANGE" transform="translate(-1222.000000, -248.000000)">
          <g id="Rectangle">
            <g id="FOOTER-SERIO">
              <g id="Group-11" transform="translate(1027.000000, 247.000000)">
                <g id="mail-blanco" transform="translate(195.000000, 1.000000)">
                  <g id="Group-8">
                    <g id="Group-29">
                      <g id="Clip-28"></g>
                      <path
                        d="M19.8447,1.9395 C9.7647,1.9395 1.5647,10.1405 1.5647,20.2195 C1.5647,30.2995 9.7647,38.5005 19.8447,38.5005 C29.9247,38.5005 38.1247,30.2995 38.1247,20.2195 C38.1247,10.1405 29.9247,1.9395 19.8447,1.9395 M19.8447,40.0005 C8.9377,40.0005 0.0647,31.1265 0.0647,20.2195 C0.0647,9.3135 8.9377,0.4395 19.8447,0.4395 C30.7517,0.4395 39.6247,9.3135 39.6247,20.2195 C39.6247,31.1265 30.7517,40.0005 19.8447,40.0005"
                        id="Fill-27"
                        fill={color || "#FFFFFF"}
                        mask="url(#mask-2)"
                      ></path>
                    </g>
                    <path
                      d="M22.4121,21.2339 L26.8301,25.6659 L12.8671,25.6659 L17.2991,21.2409 L18.5181,22.3969 C19.2581,23.0979 20.4461,23.0989 21.1851,22.3969 L22.4121,21.2339 Z M28.0151,15.9079 L28.0151,24.9289 L23.3911,20.2979 L28.0151,15.9079 Z M11.6761,15.9079 L16.3131,20.3049 L11.6761,24.9289 L11.6761,15.9079 Z M12.4551,14.7739 L27.2411,14.7739 L20.2491,21.4109 C19.9951,21.6529 19.7101,21.6529 19.4551,21.4109 L12.4551,14.7739 Z M12.3561,13.4119 C11.2231,13.4119 10.3131,14.3689 10.3131,15.5039 L10.3131,24.9289 C10.3131,26.0639 11.2231,27.0279 12.3561,27.0279 L27.3341,27.0279 C28.4681,27.0279 29.3761,26.0639 29.3761,24.9289 L29.3761,15.5039 C29.3761,14.3689 28.4681,13.4119 27.3341,13.4119 L12.3561,13.4119 Z"
                      id="Fill-30"
                      fill={color || "#FFFFFF"}
                    ></path>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}
